import { render, staticRenderFns } from "./checkPwd.vue?vue&type=template&id=2bd7d461&"
import script from "./checkPwd.vue?vue&type=script&lang=js&"
export * from "./checkPwd.vue?vue&type=script&lang=js&"
import style0 from "./checkPwd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports